;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="7d1d58d2-1733-4cb9-a5fa-2d53a6e3de82",e._sentryDebugIdIdentifier="sentry-dbid-7d1d58d2-1733-4cb9-a5fa-2d53a6e3de82")}catch(e){}}();import React__default, { forwardRef, useContext, useCallback, useEffect } from 'react';
import { LayoutContainer } from '@zooplus/ui-components';
import AppContext from '../../context/AppContext.js';
import '../../_virtual/_sentry-release-injection-file.js';
import { CategoryTypeEnum } from '../../types/index.js';
import AnimalFlyout from './AnimalFlyout.js';
import { AnimalFlyoutV2 } from './AnimalFlyoutV2.js';
import styles from './CategoryFlyout.module.scss.js';
import SpecialOffersFlyout from './SpecialOffersFlyout.js';
import TopBrandsFlyout from './TopBrandsFlyout.js';

function CategoryFlyoutWithoutRef(props) {
    const { isArtificialCategoriesEnabled } = useContext(AppContext);
    const { category, show, forwardedRef, onMouseEnter, onMouseLeave } = props;
    const { type } = category;
    const activeElementIsContained = useCallback(() => {
        return new Promise((resolve) => {
            setImmediate(() => {
                if (forwardedRef) {
                    resolve(forwardedRef.current.contains(document.activeElement));
                }
                resolve(false);
            });
        });
    }, [forwardedRef]);
    const onBlurFirstItem = useCallback(async () => {
        const { onBlurFirst } = props;
        const isContained = await activeElementIsContained();
        if (!isContained) {
            onBlurFirst();
        }
    }, [activeElementIsContained, props]);
    const onBlurLastItem = useCallback(async () => {
        const { onBlurLast } = props;
        const isContained = await activeElementIsContained();
        if (!isContained) {
            onBlurLast();
        }
    }, [activeElementIsContained, props]);
    const onEscape = useCallback((event) => {
        const { onBlurFirst } = props;
        if (event.key === 'Escape') {
            onBlurFirst();
        }
    }, [props]);
    useEffect(() => {
        if (forwardedRef) {
            const all = forwardedRef.current.querySelectorAll('a');
            if (all) {
                const first = all[0];
                const last = all[all.length - 1];
                if (show) {
                    first.addEventListener('focusout', () => onBlurFirstItem);
                    last.addEventListener('focusout', () => onBlurLastItem);
                    document.addEventListener('keyup', onEscape);
                }
                else {
                    first.removeEventListener('focusout', () => onBlurFirstItem);
                    last.removeEventListener('focusout', () => onBlurLastItem);
                    document.removeEventListener('keyup', onEscape);
                }
            }
        }
    }, [forwardedRef, onBlurFirstItem, onBlurLastItem, onEscape, show]);
    return (React__default.createElement(LayoutContainer, { variant: "default", className: styles.flyOut, ref: forwardedRef, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, id: "header-category-flyout", style: {
            '--header-category-flyout-display-flag': `${show ? 'block' : 'none'}`,
        } },
        React__default.createElement("div", { className: styles.flyOutContainer },
            (type === CategoryTypeEnum.ANIMAL ||
                type === CategoryTypeEnum.NORMAL) && (React__default.createElement(React__default.Fragment, null, isArtificialCategoriesEnabled ? (React__default.createElement(AnimalFlyoutV2, { category: category })) : (React__default.createElement(AnimalFlyout, { category: category })))),
            type === CategoryTypeEnum.BRANDS && (React__default.createElement(TopBrandsFlyout, { category: category })),
            (type === CategoryTypeEnum.OFFERS ||
                type === CategoryTypeEnum.OUTLET) && (React__default.createElement(SpecialOffersFlyout, { category: category })))));
}
const CategoryFlyoutWithRef = (props, ref) => {
    const { category, show, onMouseEnter, onMouseLeave, onBlurLast, onBlurFirst, } = props;
    return (React__default.createElement(CategoryFlyoutWithoutRef, { category: category, forwardedRef: ref, onBlurFirst: onBlurFirst, onBlurLast: onBlurLast, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, show: show }));
};
var CategoryFlyout = forwardRef(CategoryFlyoutWithRef);

export { CategoryFlyoutWithoutRef, CategoryFlyout as default };
//# sourceMappingURL=CategoryFlyout.js.map
